import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import React, { Fragment, useState } from 'react';
import classnames from 'classnames';

import Select, { ActionMeta, OptionsType, ValueType } from 'react-select';

type OptionType = { label: string; value: string | number };

type Props = {
  className?: string;
  confirmationMessage?: string;
  confirmationTitle?: string;
  confirmSelection?: boolean;
  isClearable?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  label?: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: OptionType & any, meta?: ActionMeta<OptionType>) => void;
  options: OptionsType<OptionType>;
  placeholder?: string;
  value?: OptionType | null;
};

export const baseSelectStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 600 }),
  control: (base: any) => ({
    ...base,
    fontSize: '80%',
    minHeight: null,
  }),
  menu: (base: any) => ({
    ...base,
    fontSize: '80%',
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    padding: 0,
    fontSize: '50%',
  }),
};

const PropertySelector: React.FC<Props> = (props: Props) => {
  const { className = '' } = props;

  const [showModal, setShowModal] = useState<boolean>(false);
  const [nextValue, setNextValue] = useState<any>();

  const onChange = (value: ValueType<OptionType, false>, meta: ActionMeta<OptionType>) => {
    if (!props.confirmSelection) {
      props.onChange(value, meta);
      return;
    }

    const apparentSelection = meta.action === 'clear' ? undefined : value;
    const selectedId = apparentSelection ? apparentSelection.value : undefined;
    const currentSelection = props.value ? props.value.value : undefined;

    if (selectedId === currentSelection) {
      return;
    }

    setNextValue(value);
    setShowModal(true);
  };

  return (
    <Fragment>
      <ConfirmModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        onConfirm={() => {
          setShowModal(false);
          props.onChange(nextValue);
        }}
        title={props.confirmationTitle || 'Confirm'}
        message={props.confirmationMessage || 'Are you sure you wish to proceed?'}
      />
      <div className={classnames(className)}>
        {props.label && (
          <small>
            <label>{props.label}</label>
          </small>
        )}

        <Select
          menuPortalTarget={document.body}
          isDisabled={props.isDisabled}
          placeholder={props.placeholder}
          options={props.options}
          onChange={onChange}
          isLoading={props.isLoading}
          isClearable={props.isClearable}
          value={props.value || null}
          styles={baseSelectStyles}
        />
      </div>
    </Fragment>
  );
};

export default PropertySelector;
